import { render } from "./HeaderBlock.vue?vue&type=template&id=2a3d1bce&scoped=true"
import script from "./HeaderBlock.vue?vue&type=script&lang=js"
export * from "./HeaderBlock.vue?vue&type=script&lang=js"

import "./HeaderBlock.vue?vue&type=style&index=0&id=2a3d1bce&scoped=true&lang=scss"

import exportComponent from "/Users/macbook/Documents/freelance/naks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3d1bce"]])

export default __exports__